export default __webpack_public_path__ + "static/media/residencial.0d98fc65.jpg";